var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "20px",
    viewBox: "0 0 14 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPinLocation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-icon",
    transform: "translate(-13.000000, -10.000000)",
    fillRule: "nonzero",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9439809,10 L19.9111402,10 C16.0979715,10 13,12.8097033 13,16.2616244 C13,18.5239828 14.1384772,21.5124854 16.3789418,25.1395569 C17.4060259,26.7946797 18.5306781,28.3872262 19.7469368,29.9087545 C19.7969148,29.9675277 19.8704864,30.0009693 19.9476299,29.9999786 L19.9476299,29.9999786 C20.0267409,29.9988422 20.1008596,29.9611091 20.1483229,29.8978076 C20.1483229,29.8759138 21.8377939,27.5843636 23.4907751,24.7892562 C25.7202929,21.0052792 26.8514721,18.1408415 26.8514721,16.2689223 C26.8551211,12.8242991 23.7535006,10 19.9439809,10 Z M23.1368255,16.4148809 C23.1368255,18.0167767 21.6991332,19.3340531 19.929385,19.3340531 C18.1596369,19.3340531 16.7219446,18.0313725 16.7219446,16.4148809 C16.7219446,14.7983893 18.1596369,13.4957087 19.929385,13.4957087 C21.6991332,13.4957087 23.1368255,14.8129852 23.1368255,16.4148809 Z",
    id: "icPinLocation"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinLocation);
export default __webpack_public_path__ + "static/media/icPinLocation.80ccb2d12e7cc0e33e80adabfb827dcc.svg";
export { ForwardRef as ReactComponent };